import styled from 'styled-components'

export const DashedLineContainer = styled.div`
  display: grid;
  place-items: center;
  z-index: -100;
`
